import { render } from "./headerDesktop.vue?vue&type=template&id=9a240874"
import script from "./headerDesktop.vue?vue&type=script&lang=js"
export * from "./headerDesktop.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__